import React, { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import styled from 'styled-components';

import { useGetRecentlyViewedGoodList } from '@ecp/common/src/hooks/user/useRecentlyViewedGoodList';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import { SITE_KOREANAIR_SAVINGS, SITE_SKYPASS, SITE_ASIANA } from '@ecp/common/src/const/site/siteNumberConst.js';

import { categoryListState } from '@fo-recoil/category/atom';
import { recentlyViewedGoodListState, userInfoState } from '@fo-recoil/common/user/atom';
import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import goodListApi from '@fo-apis/good/goodListApi';
import displayApi from '@fo-apis/display/displayApi';
import Gnb from '@fo-pages/home/gnb/Gnb';
import Footer from '@fo-pages/home/footer/Footer';
import EventMallGnb from '@fo-pages/eventMall/gnb/Gnb';
import { useSiteComponentResolver } from '@ecp/fo/src/hooks/resolver/SiteComponentResolverHook';
import SkypassGnb from '@ecp/fo/sites/skypass/components/gnb/SkypassGnb';
import AsianaGnb from '@ecp/fo/sites/asiana/components/gnb/AsianaGnb';
import SkypassFooter from '@ecp/fo/sites/skypass/components/footer/SkypassFooter';
import KoreanAirSavingsGnb from '@ecp/fo/sites/koreanairSavings/components/gnb/KoreanAirSavingsGnb';

const HomePage = () => {
  const { isEventMall, getSystemInformationByKey, siteNumber } = useSiteInfo();
  const isAsiana = useMemo(() => siteNumber === SITE_ASIANA, [siteNumber]);
  const isKoreanair = useMemo(() => siteNumber === SITE_KOREANAIR_SAVINGS, [siteNumber]);

  const setCategoryList = useSetRecoilState(categoryListState);
  const userInfo = useRecoilValue(userInfoState);
  const [recentlyViewedList, setRecentlyViewedList] = useRecoilState(recentlyViewedGoodListState);

  useGetRecentlyViewedGoodList(userInfo, recentlyViewedList, setRecentlyViewedList, goodListApi.getGoodDisplayableList);

  useEffect(() => {
    console.debug(
      'siteName: ',
      getSystemInformationByKey('siteName'),
      ', isEventMall: ',
      isEventMall,
      ', isAsiana: ',
      isAsiana,
      ', siteTypeCode:',
      getSystemInformationByKey('siteTypeCode')
    );
    (async () => {
      const { result } = await displayApi.getDisplayCategory({ skipSpinner: true });
      setCategoryList(result);
    })();
  }, [getSystemInformationByKey, isEventMall, isAsiana, setCategoryList]);

  const ResolvedGnb = useSiteComponentResolver(<Gnb />, {
    // 대한항공
    [SITE_SKYPASS]: <SkypassGnb />,
  });

  const ResolvedFooter = useSiteComponentResolver(<Footer />, {
    // 대한항공
    [SITE_SKYPASS]: <SkypassFooter />,
  });

  return (
    <StyledFlexBoxColumn width={'100%'}>
      {isAsiana ? <AsianaGnb /> : isKoreanair ? <KoreanAirSavingsGnb/> : isEventMall ? <EventMallGnb /> : ResolvedGnb}
      <PageWrapper id="contents" tabIndex={0}>
        <Outlet />
      </PageWrapper>
      {isEventMall ? <Footer showInquiry={false} /> : ResolvedFooter}
    </StyledFlexBoxColumn>
  );
};

const StyledFlexBoxColumn = styled(FlexBoxColumn)`
  min-width: 1630px;
  min-height: 100vh;
`;

const PageWrapper = styled(FlexBox)`
  flex: 1;
  align-items: flex-start;
  min-height: calc(100vh - 407px);
  padding-left: 14px;
  margin-left: -14px;
`;
export default HomePage;
